import Vue from "vue";
import Vuex from "vuex";
// import { login } from "../api/index";
// import { Toast } from "vant";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      // token: 'sdaudhsakjdsasdjlfjk',
    },
  },
  mutations: {
    // 同步修改用户
    setState(state, play) {
      state.user = play;
    },
  },
  actions: {
    // 同步修改用户
    // async login(content, payload) {
    //   // 将表单提交的账号密码进行提交  playload需要有参数{username,password}
    //   // 当登录成功 后端返回用户的数据，进行修改用户信息
    //   // 保存登录的token
    //   let res = await login(payload);
    //   // console.log(res);
    //   if (res.msg === "fail") {
    //     // alert(res.result)
    //     Toast({
    //       message: res.result,
    //       icon: "./imgs/fail.png",
    //     });
    //   } else {
    //     Toast({
    //       message: "登录成功",
    //       icon: "certificate",
    //     });
    //     content.commit("setState", res.result);
    //     localStorage.token = res.result.token;
    //     localStorage.user = JSON.stringify(res.result);
    //     return res.msg;
    //   }
    // },
  },
  modules: {},
});
